/* Renders pagination dots for a Splide instance.
   Number of dots = number of distinct scroll positions, computed from
   Splide's Controller.getEnd() + 1 (which is `length - perPage + 1` for
   type:'slide', perMove:1). This gives one dot per "stop" — exactly the
   model the design calls for: 8 slides perPage 4 → 5 dots; 4 slides
   perPage 1 → 4 dots. Recomputes on resize so breakpoint perPage
   changes keep the dot count honest. */
(function () {
  function init(splide, container) {
    if (!splide || !container) return;
    container.classList.add('scent-dots');

    function rebuild() {
      var Controller = splide.Components && splide.Components.Controller;
      if (!Controller) return;
      var endIdx = Controller.getEnd();
      var dotCount = (endIdx >= 0 ? endIdx : splide.length - 1) + 1;

      container.innerHTML = '';
      if (dotCount <= 1) {
        container.hidden = true;
        return;
      }
      container.hidden = false;

      for (var i = 0; i < dotCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'scent-dots__dot';
        dot.setAttribute('aria-label', 'Aller à la diapositive ' + (i + 1));
        dot.dataset.index = String(i);
        dot.addEventListener('click', onDotClick);
        container.appendChild(dot);
      }
      syncActive();
    }

    function onDotClick() {
      var i = parseInt(this.dataset.index, 10);
      if (!isNaN(i)) splide.go(i);
    }

    function syncActive() {
      var dots = container.querySelectorAll('.scent-dots__dot');
      if (!dots.length) return;
      var endIdx = dots.length - 1;
      var active = Math.min(splide.index, endIdx);
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === active);
      }
    }

    splide.on('mounted resized', rebuild);
    splide.on('move moved', syncActive);
    rebuild();
  }

  window.initScentSplideDots = init;
})();
